import React, { useContext, useEffect, useState } from 'react';
import styles from './People.module.css';
import IsAuth from '../../../createContext/is-Auth/IsAuthContext';
import { ProfileContext } from '../../../createContext/Profile/ProfileContext';
import { Link } from 'react-router-dom';

const People = ({ users = [] }) => {
  const { user } = useContext(IsAuth);
  const [people, setPeople] = useState(users);
  const { toggleFollow } = useContext(ProfileContext);

  useEffect(() => {
    setPeople(
      users.map((userItem) => ({
        ...userItem,
        followStatus: getInitialFollowStatus(userItem),
      }))
    );
  }, [users, user]);

  const getInitialFollowStatus = (userItem) => {
    if (user.following?.some(followed => followed?._id === userItem._id)) {
      return 'following';
    } else if (userItem.followRequests?.includes(user._id)) {
      return 'requested';
    }
    return 'none';
  };

  const handleFollow = async (userId) => {
    try {
      const response = await toggleFollow(userId);
      
      setPeople((prevPeople) =>
        prevPeople.map((userItem) => {
          if (userItem._id !== userId) return userItem;

          let newStatus;
          let followersDelta = 0;

          if (userItem.followStatus === 'following') {
            newStatus = 'none';
            followersDelta = -1;
          } else if (response?.data?.status === 'followed') {
            newStatus = 'following';
            followersDelta = 1;
          } else if (response?.data?.status === 'requested' || response?.data?.status === 'pending') {
            newStatus = 'requested';
            followersDelta = 0;
          } else {
            newStatus = 'none';
            followersDelta = 0;
          }

          return {
            ...userItem,
            followStatus: newStatus,
            followers: userItem.followers + followersDelta
          };
        })
      );
    } catch (error) {
      console.error('Error toggling follow:', error);
    }
  };

  const renderFollowButton = (userItem) => {
    switch (userItem.followStatus) {
      case 'following':
        return (
          <button 
            className={`${styles.followBtn} ${styles.following}`}
            onClick={() => handleFollow(userItem._id)}
          >
            Unfollow
          </button>
        );
      case 'requested':
        return (
          <button 
            className={`${styles.followBtn} ${styles.requested}`}
            disabled
          >
            Requested
          </button>
        );
      default:
        return (
          <button 
            className={styles.followBtn}
            onClick={() => handleFollow(userItem._id)}
          >
            {userItem.isPrivate ? 'Request to Follow' : 'Follow'}
          </button>
        );
    }
  };

  return (
    <div className={styles.followList}>
      {people.map((_user, index) => (
        <div className={styles.userCard} key={index}>
          <img src={_user.avatar} alt={`profile`} className={styles.profileImage} />
          <div className={styles.userInfo}>
            <Link to={`/profile/${_user.userName}`}>
              <h3>{_user.name} <span>{_user.followers} Followers</span></h3>
            </Link>
            <p>{_user.userName}</p>
            <p>{_user.bio}</p>
          </div>
          {renderFollowButton(_user)}
        </div>
      ))}
    </div>
  );
};

export default People;